export default __webpack_public_path__ + "static/media/cortex.ab93462e.png";